import React, { useMemo, useState } from "react";

import {
  useGetQuotes,
  usePutQuoteStage,
} from "../../hooks/react-query/useSalesData";
import { QUOTE_STAGE_LABELS } from "../../constants/salesStages";

import KanbanBoard from "./KanbanBoard";
import QuoteCard from "./QuoteCard";
import QuoteStageActionsDialog from "./QuoteStageActionsDialog";
import SalesEmpty from "./SalesEmpty";
import { StartComponent } from "./SalesLeadsKanban";

const stageHasPrompt = (stage) => {
  const info = QUOTE_STAGE_LABELS.find((s) => s.id === stage);
  return !!(info?.promptUpload || info?.promptCreate);
};

const findQuote = (columns, id) => {
  for (const col of columns || []) {
    const found = col.elements?.find((e) => Number(e.id) === id);
    if (found) return found;
  }
  return null;
};

const SalesQuotesKanban = () => {
  const { data, isLoading } = useGetQuotes();
  const { mutate: putStage } = usePutQuoteStage();
  const [prompt, setPrompt] = useState(null);

  const totalItems = useMemo(
    () => (data || []).reduce((sum, col) => sum + col.elements.length, 0),
    [data],
  );

  const moveStage = ({ id, stage }) => {
    const quote = findQuote(data, id);
    putStage(
      { id, stage },
      {
        onSuccess: () => {
          console.log({ quote, stage });
          if (quote && stageHasPrompt(stage)) setPrompt({ quote, stage });
        },
      },
    );
  };

  if (!isLoading && !totalItems) return <SalesEmpty type="quote" />;

  return (
    <>
      <KanbanBoard
        columns={data || []}
        CardComponent={QuoteCard}
        onStageChange={moveStage}
        isLoading={isLoading}
        StartComponent={StartComponent}
      />
      {prompt && (
        <QuoteStageActionsDialog
          quote={prompt.quote}
          stage={prompt.stage}
          onClose={() => setPrompt(null)}
        />
      )}
    </>
  );
};

export default SalesQuotesKanban;
